export { default as RestaurantDetailsModal } from './restaurant-details-modal';
